<template>
  <div class="navbar-wrapper">
    <preloader v-if="showPreloader"></preloader>
    <base-nav type="primary" class="mb-2" effect="dark" expand title='CTM Logistics Driver' :badgeType="statusColor" :badgeText='status'>
      <div class="row" slot="content-header" slot-scope="{closeMenu}">
          <div class="col-6 collapse-brand">
            <router-link to="/">CTM Logistics Driver</router-link>
          </div>
          <div class="col-6 collapse-close">
              <close-button @click="closeMenu"></close-button>
          </div>
      </div>

      <ul class="navbar-nav ml-lg-auto">

          <li v-if="!isLogin" class="nav-item sign-in">
              <a class="nav-link nav-link-icon" @click="signInModal = true">
                  SignIn
              </a>
          </li>
          <base-dropdown v-if="isLogin" tag="li" :title=userName>
            <a class="dropdown-item" href="#">Profile</a>
            <a style="cursor: pointer" class="dropdown-item" @click="signOut">Signout</a>
          </base-dropdown>
      </ul>
    </base-nav>
     <modal :show.sync="signInModal"
            @close="formClear"
            body-classes="p-0"
            modal-classes="modal-dialog-centered modal-sm">
            <sign-in
              @closeModal="closeModal"
              ref="form"
              >
            </sign-in>
    </modal>
  </div>
</template>

<script>

import Modal from '@/components/Modal'
import Preloader from '@/components/Preloader'
import BaseNav from '@/components/BaseNav'
import CloseButton from '@/components/CloseButton'
import BaseDropdown from '@/components/BaseDropdown'
import SignIn from '@/views/SignIn/SignIn'

export default {
  data () {
    return {
      showPreloader: false,
      signInModal: false,
      required: true,
      modalIsClose: ''
    }
  },
  computed: {
    status () {
      return this.isOnline ? 'Online' : 'Offline'
    },
    statusColor () {
      return this.isOnline ? 'secondary' : 'danger'
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    userName () {
      let username = this.$store.state.user.name
      return username || 'Username'
    }
  },
  methods: {
    closeModal () {
      let self = this
      this.showPreloader = true
      setTimeout(function () {
        self.signInModal = false
        self.formClear()
        this.showPreloader = false
        window.location.reload(false)
      }, 3000)
    },
    formClear () {
      // Clear errors in SignIn form
      this.$refs.form.vErrors.clear()
    },
    signOut () {
      this.$store.commit('changeLoginStatus', false)
      this.$router.push({ path: '/' })
      window.localStorage.clear()
      this.$store.dispatch('logout', this.$store.state.user.token)
        .then(response => {
          location.reload()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    SignIn,
    Modal,
    Preloader
  }
}
</script>
<style lang="css">
  .navbar .badge {
    padding: 4px;
    top: -10px;
    position: relative;
    margin-left: 5px;
  }
  .sign-in {
    cursor: pointer;
  }
  .navbar-wrapper {
    position: relative;
    z-index:10;
  }
</style>
